import React, { useCallback } from 'react';
import Conditional from '../../../common/conditional';

import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';

import { getSummaryScanDataColumns } from '../../../../utils/data';
import css from './style.module.scss';

const CustomPecScanTable: React.FC<Pick<models.PDFTableProps, 'data'>> = (props) => {
	const getResultStyle = useCallback((dataItem: { result: string }) => {
		if (dataItem.result.toLowerCase().indexOf('accept') !== -1) {
			return { backgroundColor: '#3ae774', color: '#000000' };
		}

		if (dataItem.result.toLowerCase().indexOf('reject') !== -1) {
			return { backgroundColor: '#eb5757', color: '#ffffff' };
		}

		return undefined;
	}, []);

	return (
		<React.Fragment>
			<div className="table-responsive">
				<table className={css.pecScanTable}>
					<thead>
						<tr>
							<th rowSpan={2}>Zone Number</th>
							<th colSpan={2}>Scan Area</th>
							<th rowSpan={2}>Nominal Thickness</th>
							<th rowSpan={2}>Corrosion Allowance</th>
							<th colSpan={4}>Minimum Thickness and Location</th>
							<th rowSpan={2}>Max. Thickness (mm)</th>
							<th rowSpan={2}>Average Thickness (mm)</th>
						</tr>
						<tr>
							<th>Axial Length</th>
							<th>Circ. Length</th>
							<th>Min. Thickness (mm)</th>
							<th>Wall Thickness Loss (%)</th>
							<th>Axial Loc.</th>
							<th>Circ. Loc.</th>
						</tr>
					</thead>

					<tbody>
						<Conditional isVisible={props.data.length > 0}>
							{props.data.map((item, index: number) => (
								<React.Fragment key={index}>
									<tr>
										<td rowSpan={2}>{item.sectionName}</td>
										{getSummaryScanDataColumns().map(
											(column: models.Column) => (
												<td
													key={column.path}
													style={utils.renderStyle(item, column)}
												>
													{utils.renderCell(item, column, index)}
												</td>
											)
										)}
									</tr>
									<tr>
										<td
											colSpan={10}
											className={css.pecScanTableResult}
											style={getResultStyle(item)}
										>
											<span>Result</span>: {item.result}
										</td>
									</tr>
								</React.Fragment>
							))}
						</Conditional>
					</tbody>
				</table>
			</div>

			<Conditional isVisible={props.data.length === 0}>
				<div className="bg-light border p-1 m-2 text-center fw-bold fs-6">
					Nil
				</div>
			</Conditional>
		</React.Fragment>
	);
};

export default CustomPecScanTable;
